var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeasurementsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.294 9.883v5.17h5.36l-1.117-1.078H6.412v-3.014L5.294 9.883z",
    fill: "#192048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.755 17.912-1.604-1.569v1.413H2.5v-2.238h1.118v-.862H2.5V11.07h1.118v-.862H2.5v-3.45h1.118v-.863H2.5V2.88l8.91 8.545v-1.52L2.338 1.199a.578.578 0 0 0-.611-.118.555.555 0 0 0-.252.2.525.525 0 0 0-.093.3v16.714c0 .143.059.28.164.381a.57.57 0 0 0 .395.158h17.417c.111.001.22-.03.313-.09a.544.544 0 0 0 .207-.242.52.52 0 0 0-.123-.59z",
    fill: "#192048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.678 16.671h2.236c.297 0 .581-.113.79-.316a1.06 1.06 0 0 0 .328-.762V5.187l-1.285-2.28a1.1 1.1 0 0 0-.416-.399 1.15 1.15 0 0 0-.568-.14 1.148 1.148 0 0 0-.576.159 1.094 1.094 0 0 0-.408.423L12.56 5.198v10.395c0 .286.118.56.328.762.21.203.494.316.79.316zm0-11.214 1.085-2.033 1.151 2.038v7.974h-2.236v-7.98zm0 8.858h2.236v1.316h-2.236v-1.316z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementsIcon);
export default __webpack_public_path__ + "static/media/measurements_icon.3cd6b060c084a3adca36af476520fefe.svg";
export { ForwardRef as ReactComponent };